import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//
import { Card, Dropdown, Nav, Tab } from "react-bootstrap";
//
import PageHeader from "../../../components/general/PageHeader";

function NotificationsConfig({ windowSize }) {
  const [activeTab, setActiveTab] = useState("Pair Configs");
  let items = [
    {
      name: "Pair Configs",
      value: "pair",
    },
  ];
  return (
    <div id="notifications">
      <PageHeader title="Notifications Config" />

      <Tab.Container defaultActiveKey="pair">
        {windowSize > 768 && (
          <div className="tab-header">
            <Nav className="align-items-end">
              {items.map((item, index) => (
                <Nav.Item key={index}>
                  <Nav.Link
                    eventKey={item.value}
                    onClick={() => setActiveTab(item.name)}
                  >
                    {item.name}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </div>
        )}

        <Card>
          {windowSize <= 768 && (
            <Card.Header className="with-dropdown tab-dropdown-header">
              <Dropdown id="tab-dropdown">
                <Dropdown.Toggle>{activeTab}</Dropdown.Toggle>
                <Dropdown.Menu className="fit">
                  <Nav>
                    {items.map((item, index) => (
                      <Nav.Item key={index}>
                        <Nav.Link
                          eventKey={item.value}
                          onClick={() => setActiveTab(item.name)}
                        >
                          {item.name}
                        </Nav.Link>
                      </Nav.Item>
                    ))}
                  </Nav>
                </Dropdown.Menu>
              </Dropdown>
            </Card.Header>
          )}

          <Card.Body>
            <Tab.Content>
              <Tab.Pane eventKey="pair" mountOnEnter unmountOnExit>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Molestias aliquam deserunt expedita eius voluptatibus sequi vero
                enim ullam error facilis esse dicta alias fuga nobis laudantium
                modi, voluptas rem! Quae!
              </Tab.Pane>
            </Tab.Content>
          </Card.Body>
        </Card>
      </Tab.Container>
    </div>
  );
}

NotificationsConfig.propTypes = {
  windowSize: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  windowSize: state.themeReducer.windowSize,
});

export default connect(mapStateToProps)(NotificationsConfig);
